import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=f24b7d1e&"
import script from "./Time.vue?vue&type=script&lang=ts&"
export * from "./Time.vue?vue&type=script&lang=ts&"
import style0 from "./Time.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports